export interface sendMessagePayload {
    to: string,
    message: string,
    attachments?: {
        buffer?: string,
        fileType?: string,
        fileName?: string,
        url?: string
    }[],
    orgID: string,
    departmentID?: string,
    subject?: string,
    source: string,
    medium?: string,
    from: string,
    ticketCode?: string
}

export enum TicketSource {
    WHATSAPP = 'whatsapp',
    SMS = 'sms',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    EMAIL = 'email',
    TIKTOK = 'tiktok'
}

export enum TicketMedium {
    CLICKATELL = 'clickatell',
    VONAGE = 'vonage',
    TWILLO = 'twillo',
    WHATSAPP_WEB = 'whatsappWeb',
    META = 'meta'
}